export const TextContentData = [
    {
        heading: 'Who we are',
        content:
            'The Dr. Mohammed Audu Foundation was established to serve as a beacon of hope and access especially for individuals and communities suffering silently from substance use disorders, mental health challenges, and other psychosocial distress, yet lack access to professional support.',
    },
    {
        heading: 'Our mission is clear: to reach the under-reached and restore dignity to the underserved.',
        content:
            'Founded by Dr. Mohammed Audu, a seasoned mental health professional with over a decade of experience in both theoretical research, hands-on clinical practice and policy formulation, the Foundation represents a deeply personal and professional commitment to change lives not in theory, but in real, practical, and sustainable ways.',
    },
];
